import React, { useEffect, useState } from "react";

import { mapDealsToFeaturedDeals } from "@app/api/wp-page-fetcher/module-selector/module-mappers";
import { useAppSelector } from "@app/redux/store";
import { FeaturedDealsSearchModule } from "@app/api/modules/featured-deals-search/featured-deals-search.module";
import { SearchApi } from "@app/bf-api";
import { IOutFeaturedDealDTO } from "@app/components/deal-cards/new-deal-card";
import { combineFilters } from "@app/api/wp-page-fetcher/utils/combine-filters";
import { FeaturedLayout } from "@app/components/featured-layout/featured-layout";
import { DealCardWrapper } from "@app/components/deal-cards/deal-card-wrapper/deal-card-wrapper";

export interface IFeaturedDealsComponentProps {
  module: FeaturedDealsSearchModule;
}

const FeaturedDealsSearch = (props: IFeaturedDealsComponentProps) => {
  const { platformId } = useAppSelector((state) => state.settings);

  const {
    title,
    subtitle,
    topCtaTitle,
    useSeeMoreCard,
    ctaButton,
    ctaDescription,
    featuredDeals,
    pageUrl,
    amountOfDeals,
    searchValue,
    searchValueEAN,
    brandSelection,
    categorySelection
  } = props.module;
  const [deals, setDeals] = useState<IOutFeaturedDealDTO[]>(featuredDeals || []);
  const filterIds = combineFilters([brandSelection, categorySelection]) || undefined;

  useEffect(() => {
    getDeals();
  }, [pageUrl]);

  const getDeals = async (): Promise<void> => {
    const api = new SearchApi();
    const result = await api.findAllEntitiesByFilters({
      platformId,
      skip: 0,
      take: amountOfDeals,
      modules: "deals",
      searchText: searchValue,
      searchEAN: searchValueEAN,
      filters: filterIds
    });
    setDeals(mapDealsToFeaturedDeals(result.deals?.data || []));
  };

  const dealsToUse = deals && deals.length > 0 ? deals : featuredDeals;

  if (!dealsToUse || dealsToUse.length === 0) {
    return <></>;
  }

  return (
    <FeaturedLayout
      title={title}
      subtitle={subtitle}
      items={dealsToUse}
      renderItem={(item) => <DealCardWrapper deal={item} />}
      topCtaTitle={topCtaTitle}
      ctaCard={
        useSeeMoreCard
          ? {
              title: ctaDescription,
              subtitle: ctaButton?.title,
              href: ctaButton?.url || ""
            }
          : undefined
      }
      mobileMaxItemAmt={props.module.amountOfDealsMobile}
    />
  );
};

export { FeaturedDealsSearch };
